module.exports = __webpack_public_path__ + "img/government-research-light.691d5e73.webp";